import { render } from "./OurProjects.vue?vue&type=template&id=155c5a17"
import script from "./OurProjects.vue?vue&type=script&lang=js"
export * from "./OurProjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__